import { TFunction } from 'i18next';

import { ModalStateType } from '~/contexts/modal/ModalContext';
import { colors } from '~/theme/colors';

export const DEFAULT_INPUT_INCREASER = 2;
export const DEFAULT_INPUT_CURRENT = 1900;
export const DEFAULT_INPUT_LIMIT = 1800;
export const DEFAULT_NEW_LIMIT = 3600;
export const DEFAULT_PLAGIARISM_RESULT = 100;

export const featureUnlockModalConfig: Partial<ModalStateType> = {
  isFullScreen: false,
  maxWidth: '880px',
  paddingSize: '0px',
  closeButtonColor: colors.neutral_30,
  pageViewMobile: true,
};

export const getFormParams = (
  t: TFunction,
): {
  submitButtonText: string;
  cardExpiryDatePlaceholder: string;
  cardHolderPlaceholder: string;
  isCardHolderVisible: boolean;
} => {
  return {
    submitButtonText: t('general:upgrade', 'Upgrade'),
    cardExpiryDatePlaceholder: 'MM/YY',
    cardHolderPlaceholder: t('general:cardholder_name', 'Cardholder Name'),
    isCardHolderVisible: true,
  };
};

export const PREMIUM_FEATURE_PURCHASE_SOURCE = 'premium_feature';
